// Investiture
import React from 'react';
import SocialStudiesCCAClass3to52025 from '../views/SocialStudiesCCAClass3to52025';

const InvestiturePage = () => {
  return <SocialStudiesCCAClass3to52025 />;
};

export default InvestiturePage;
